<template>
  <div style="padding-top: 60px">
    <div class="file-upload">
      <input type="file" @change="onFileChange" />
      <button
        @click="onUploadFile"
        class="upload-button"
        :disabled="!this.selectedFile"
      >
        Upload file
      </button>
    </div>

    <div style="text-align: center">
      <button onclick="playPause()">Play/Pause</button>
      <button onclick="makeBig()">Big</button>
      <button onclick="makeSmall()">Small</button>
      <button onclick="makeNormal()">Normal</button>
      <br /><br />
      <video id="video1" width="420">
        <source src="mov_bbb.mp4" type="video/mp4" />
        <source src="mov_bbb.ogg" type="video/ogg" />
        Your browser does not support HTML video.
      </video>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "TEMPLATE",
  props: {
    // used for receive data from Parent
    // Syntax: Name of variable of Parent : Type of variable
    // Example => Courses : Array,
  },
  data() {
    return {
      selectedFile: "",
      myVideo : document.getElementById("video1"),
    };
  },
  computed: {
    // used for detect data, in this project usually detect the response data from API
    // that collect in the getters of store (vuex)
    // bringing mapGetters to detect in getters of store (vuex)
    // syntax : ...mapGetters({ Name created variable for local data : Name of getters in store })
    // Example => ...mapGetters({ courses : 'courses/allCourses' })
  },
  watch: {
    // used to manage data after detect data
    // Syntax : Existing name of local variable : function(value){ Action }
    // Example => course : function(value){ this.data = value }
    // Value in parameter is the value of detected data changing
  },
  created() {
    // used for manage event when this page open
  },
  mounted() {
    // used for manage event when data has changed
  },
  beforeDestroy() {
    // used for update value before close this page
    // สมมติว่าจับเวลาใช้ในหน้านี้กี่นาที ให้มาเก็บในนี้
  },
  methods: {
    playPause() {
      if (myVideo.paused) myVideo.play();
      else myVideo.pause();
    },

    makeBig() {
      myVideo.width = 560;
    },

    makeSmall() {
      myVideo.width = 320;
    },

    makeNormal() {
      myVideo.width = 420;
    },

    onFileChange(e) {
      const selectedFile = e.target.files[0]; // accessing file
      this.selectedFile = selectedFile;
    },
    onUploadFile() {
      const formData = new FormData();
      formData.append("file", this.selectedFile); // appending file

      // sending file to the backend
      axios
        .post("http://10.1.134.24:8000/upload", this.selectedFile)
        .then((res) => {
          console.log("");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
</style>